import globalVar from '../utils/globalVar'

class TimepiecesInfo {
  constructor() {
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let cache = {};
    let contactInView = false;
    let idleTimer     = null;
    const IDLE_DELAY  = 5000;

    let initCache = () => {
      cache.timepiecesInfo = document.querySelector('.timepieces-info');
      cache.pageContainer  = document.querySelector('.page-container');
      cache.contact        = document.querySelector('.module-15-contact');
    };

    let show = () => {
        cache.timepiecesInfo.classList.remove('is-hidden');
        cache.timepiecesInfo.style.zIndex = '999';
    };

    let hide = () => {
        cache.timepiecesInfo.classList.add('is-hidden');
        setTimeout(() => {
            cache.timepiecesInfo.style.zIndex = '0';
        }, 500);
        clearTimeout(idleTimer);
    };

    let resetIdleTimer = () => {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(() => {
            if (!contactInView) hide();
        }, IDLE_DELAY);
    };

    let setPaddingBottom = () => {
        if (cache.timepiecesInfo.previousElementSibling && !cache.timepiecesInfo.previousElementSibling.classList.contains('module-15-contact')) {
            cache.pageContainer.style.paddingBottom = cache.timepiecesInfo.offsetHeight + 'px';
        }
    };

    let registerEvents = () => {
        if (cache.timepiecesInfo && cache.pageContainer) {
            setPaddingBottom();

            let resizeTimer = null;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    setPaddingBottom();
                    updateStickyInfo();
                }, 150);
            }, { passive: true });

            window.addEventListener('scroll', () => {
                updateStickyInfo();
                if (!contactInView) {
                    show();
                    resetIdleTimer();
                }
            }, { passive: true });

            if (cache.contact) {
                new IntersectionObserver((entries) => {
                    contactInView = entries[0].isIntersecting;
                    if (contactInView) {
                        hide();
                    }
                }, { threshold: 0 }).observe(cache.contact);
            }
        }

        if(cache.contact) {
            const link = cache.timepiecesInfo.querySelector('.timepieces-info__link').href;
            cache.contact.querySelector('a').href = link;
        }
    };

    let updateStickyInfo = () => {
        const el             = cache.timepiecesInfo;
        const container      = cache.pageContainer;
        const containerBottom = container.getBoundingClientRect().bottom;
        // Use visualViewport.height on mobile to get the actual visible area,
        // avoiding the iOS Safari "large viewport" issue where window.innerHeight
        // reflects the full screen (URL bar hidden) and causes atBottom to fire early.
        const viewportHeight = (window.visualViewport ? window.visualViewport.height : window.innerHeight);
        const atBottom       = containerBottom <= viewportHeight;

        // CSS handles all positioning via `position: fixed; bottom: 0` and
        // `.is-sticky-bottom { position: absolute; bottom: 0; top: auto !important }`.
        // Never set inline top/position — that fights the CSS and breaks mobile.
        el.classList.toggle('is-sticky-bottom', atBottom);
        el.classList.toggle('is-sticky-fixed',  !atBottom);
        el.style.top      = '';
        el.style.position = '';
    };

    initFunc();
  };
}
export { TimepiecesInfo }
